const mergeRefs = function () {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return ref => {
    refs.forEach(resolvableRef => {
      if (typeof resolvableRef === "function") {
        resolvableRef(ref);
      } else if (resolvableRef) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        resolvableRef.current = ref;
      }
    });
  };
};

export { mergeRefs };
